// English messages for the work queue (Te beoordelen). Spread into en.ts.

import type { Vars } from './en.ts';

export const queueEn = {
  'queue.intro': 'Everything waiting for your approval.',
  'queue.tab.all': 'All',
  'queue.tab.document': 'Documents',
  'queue.tab.bank_match': 'Bank',
  'queue.tab.request': 'Customer requests',
  'queue.tab.proposal': 'Proposals',
  'queue.tab.operation': 'Bookings under way',
  'queue.tabs': 'Work kind',
  'queue.filter': 'Filter by state',
  'queue.filter.all': 'Every state',
  'queue.status.ready': 'Ready for approval',
  'queue.status.check': 'Needs review',
  'queue.reading': 'Reading the queue…',
  'queue.empty': 'Nothing is waiting for your approval.',
  'queue.emptyFiltered': 'Nothing in this state.',
  'queue.error.absent': 'That office is not available to this session.',
  'queue.error.read': 'The work queue could not be read.',
  'queue.select': (v: Vars) => `Select ${v['name']} for review`,
  'queue.review': (v: Vars) => `Review ${v['count']} selected`,
  'queue.reviewReading': 'Reading…',
  'queue.loadMore': 'Load more',
  'queue.loadingMore': 'Loading…',
  'queue.cols.name': 'Name',
  'queue.cols.date': 'Date',
  'queue.cols.status': 'Status',
  'queue.cols.amount': 'Amount',

  // --- the batch review -------------------------------------------------------
  'queue.batch.titleDone': 'What was sent',
  'queue.batch.title': 'Review before approving',
  'queue.batch.doneLine': (v: Vars) => `${v['queued']} queued, ${v['refused']} refused, ${v['other']} not sent.`,
  'queue.batch.line': (v: Vars) => `${v['selected']} selected · ${v['ready']} can be approved`,
  'queue.batch.document': 'Document',
  'queue.batch.invoice': 'Invoice',
  'queue.batch.total': 'Total',
  'queue.batch.revision': 'Revision',
  'queue.batch.outcome': 'Outcome',
  'queue.batch.open': 'Open',
  'queue.batch.footDone':
    'Each queued operation is sent by the worker. Only the operation itself reports whether the accounting package accepted it — open a document to follow one.',
  'queue.batch.foot':
    'Approving sends one request per item, each with its own expected revision. Nothing is sent for the rows above that cannot be approved.',
  'queue.batch.approving': 'Approving…',
  'queue.batch.approve': (v: Vars) => `Approve ${v['count']}`,
  'queue.outcome.queued': 'Queued',
  'queue.outcome.notSent': 'Not sent',
  'queue.outcome.blocked': 'Cannot be approved',
  'queue.outcome.waiting': 'Waiting…',
  'queue.outcome.ready': 'Ready to approve',
  'queue.blocked.unreadable': 'Could not be read, so nothing will be sent for it.',
  'queue.blocked.absent': 'No longer available to your session.',
  'queue.blocked.role': (v: Vars) => `Your role (${v['role']}) may not approve a booking.`,
  'queue.blocked.noProposal': 'No proposal has been prepared for this document.',
  'queue.blocked.blockers': (v: Vars) => `Stopped before preparation finished: ${v['codes']}.`,
  'queue.blocked.status': (v: Vars) => `The proposal is ${v['status']}, so there is nothing to approve.`,
  'queue.blocked.noRevision': 'This proposal has no current revision to approve.',
  'queue.refusal.generic': 'The request could not be completed.',
  'queue.refusal.stale': 'This changed after it was read, so nothing was sent for it. Review it again.',
  'queue.refusal.forbidden': 'Your role does not allow this.',
  'queue.refusal.fields': (v: Vars) => `Refused: ${v['fields']}.`,
  'queue.refusal.validation': 'validation failed',
} as const;
